<template>
    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-4">
        <a :href="company.getUrl">
            <div class="card">
                <img class="card-img-top" :src="company.image" :alt="company.first_name">
                <div class="card-body text-center">
                    <h5 v-if="company.first_name.length<15">
                       {{ company.first_name }}
                    </h5>
                     <h5 v-if="company.first_name.length>=15">
                         <b class="text-info">{{ company.first_name.substring(0,15)+'...' }}</b>
                     </h5>
                    <p class="text-center text-muted">
                        ({{ getCountry(company.country_id) }}, {{ getRegion(company.region_id) }})
                    </p>
                    <p class="text-center text-muted small">
                        {{company.city}}
                    </p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "Company",
        props: ['company', 'regions', 'countries'],
        methods:{
            getCountry(id){
                return this.countries[id];
            },
            getRegion(id){
                let key = this.regions.findIndex(x => x.id === id);
                return this.regions[key].name;
            }
        }
    }
</script>

<style scoped>

</style>